var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 10.2579V10.1662H10.2584H10.7089L14.0956 13.5689L14.0965 13.5698C14.2429 13.7162 14.2429 13.9579 14.0965 14.1043C13.9501 14.2507 13.7083 14.2507 13.5619 14.1043L10.1667 10.7091V10.2579ZM9.64541 9.11582L9.40121 9.40072L9.1163 9.64492C8.05626 10.5535 6.61265 11.0222 5.07492 10.7649C2.97602 10.4099 1.29462 8.65221 1.03805 6.53927L1.03796 6.53854C0.644311 3.33632 3.33681 0.643823 6.53903 1.03748L6.53976 1.03757C8.6527 1.29414 10.4104 2.97553 10.7653 5.07443C11.0227 6.61216 10.554 8.05577 9.64541 9.11582ZM1.6667 5.91621C1.6667 8.26735 3.56556 10.1662 5.9167 10.1662C8.26784 10.1662 10.1667 8.26735 10.1667 5.91621C10.1667 3.56507 8.26784 1.66621 5.9167 1.66621C3.56556 1.66621 1.6667 3.56507 1.6667 5.91621Z",
    fill: "#323232",
    stroke: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e0c6f333d1a7fd88a59021119edc68ea.svg";
export { ForwardRef as ReactComponent };